
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';

// Routes that render a printable document — these must always use the
// light theme regardless of the user's dark-mode preference. Under dark
// mode, Bootstrap's --bs-body-color becomes a light gray; browsers don't
// print backgrounds by default, so that light text on the white page
// prints as (near-)invisible, i.e. the page "хааяа цагаан гарч ирнэ".
const PRINT_ROUTE_PREFIXES = [
    "/print/", "/printrc/", "/printvf/",
    "/invoices/", "/minvoices/", "/oinvoices/", "/winvoices/",
];

const NonAuthLayout = ({ children }) => {

    const location = useLocation();
    const isPrintRoute = PRINT_ROUTE_PREFIXES.some((p) => location.pathname.startsWith(p));

    const selectLayoutState = (state) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            layoutThemeType: layout.layoutThemeType,
            layoutModeType: layout.layoutModeType,
        })
    );
    // Inside your component
    const {
        layoutModeType,
        layoutThemeType,
    } = useSelector(selectLayoutProperties);

    useEffect(() => {
        if (isPrintRoute) {
            document.body.setAttribute("data-bs-theme", "light");
            return () => {
                document.body.removeAttribute("data-bs-theme");
            };
        }

        document.body.setAttribute("data-theme", layoutThemeType);

        if (layoutModeType === "dark") {
            document.body.setAttribute("data-bs-theme", "dark");
        } else {
            document.body.setAttribute("data-bs-theme", "light");
        }
        return () => {
            document.body.removeAttribute("data-bs-theme");
            document.body.removeAttribute("data-theme");
        };
    }, [layoutModeType, layoutThemeType, isPrintRoute]);

    return (
        <div>
            {children}
        </div>
    )
}

export default NonAuthLayout
